<template>
  <div
    style="width: 100%; padding-bottom: 4.33333rem; background: url(/img/home/g.f7e76bcc.png) repeat top / 100% auto;"
  >
    <!-- 头部和 Banner 区域保持不变 -->
    <div class="header">
      <div class="header_content">
        <div v-if="!hasToken" @click="toLogin('/Register')">
          {{$t("auth.register")}}
        </div>
        <div v-else>
          <div style="padding: 10px 0px 0px 0px;">
            <img style="height:28px" src="/img/home/xx.png" @click="toLogin('/Notice')" />
          </div>
        </div>
        <div class="img" style="width: 60px;height: 60px;">
          <img src="/img/home/logo11.png" alt="" style="width: 60px;height: 60px;" />
        </div>
        <div
          style="display: flex; align-items: center;"
          v-if="!hasToken"
          @click="toLogin('/Login')"
        >
          <van-icon name="chat-o" color="#fff" size="24" />
          {{$t("auth.login")}}
        </div>
        <div style="padding: 10px 0px 0px 0px;" v-else @click="toLogin('/Mine')">
          <img src="/img/home/gr.png" style="height:28px" />
        </div>
      </div>
    </div>
    
    <!-- 公告和 Banner -->
    <div style="height: 160px;">
      <div style="padding: 8px;">
        <van-notice-bar class="notice-swiper" color="#000" background="#fff" scrollable :text="this.notice">
          <template #left-icon>
            <img data-v-4d36baa4="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAcCAYAAACQ0cTtAAAAAXNSR0IArs4c6QAAAzpJREFUSEutlkFoHGUUx///2Z3daAOa6s5HZqa1rcFeSm0IaTqfJeZgixQxt6qH5qQgUjCBioKHepAWrGArpoIK0ktAEdpDoEQsFEt32yhSqwdPtpjZhtn14DFks/NkZpu4MbPZCczchu+9/2++9/3f+4bY4qPU/m2S750gw18C/9btraRzK8El1xugcJbEXgH+qeUL/bh/fSmtRmqY5WiPxCyA7avioWCwXi3fyRSmXP2GANMEzHbhkBytL9y8kRnMcr1zBE8lCYZNjtYXM4D19Q09VthWnAFwrNOXJ8H67KGdBRY+BlAOqpXz7bmJZ6bUwd2Sz1+NjLBZiZJglqOnSbwV5QnwXc0vvAZcX4neN8BK9shhg7nLIJ7sdhaJMFsfpYErAB6J80W+DaqVVzbAYiMILpLIdwNF653OrGR7gwY5B6L0cIfv1vzyR7QcfZGUFyEgyF1pIGvW32iQHIBmtG65I/uJ3DyAIiDLTRq7qVwtWwGss34bbLs9vMOkeRPE3cAvvxQDbe8UDZ6LqyByITOYZY8coZH7PhamnKwvVKaBIVM5RR+EJcBiZrB4J46+QeIwBH8H1UJ/5ELl6i8BvB4bJKsytsoWO3GuZYrmszX/9l3LOfQmaXyeOezxfv1UMYf7MSyU52oPKuWSc+i4QeObzGGW402QvBSbqNF4Ogh++lO53tsA40mSWRlLpbFeFpf/IOAA+Dnwy8OtFtBXCIxnClO2HkdrcgBheCR4cOsHpbQFE39FvSbAr1FTN9JOjP/3Y/sEse2hR5ssfgbiTuCXP22507tEcqKVJ5NUSu+DCU8ES4BMkRxM2+SbXTHtLhSIXwOeWT+Id431WI3lL0icSAPsOBtd7z0DPLumIfJCUK1cS75iHP0+iA+7AZNgyvEmQX7yX65MBn7lQmyQToLK1q/CwNcAejrFJF4xrv6AwGkBGoS8swraFBYtPrFDD+dDzEazLQnYoYw5ZXvHYeD3wK/81p7X9e9KqeE9YppzBAY2c2O3knfd2apA1C9iIgIeaBcNiefrC+Uf04BSw6LA6E8Y+d4ZEC+viTdW9gTB/L3MYQ8FqWzvDMiTIeSrerUylRYUxf0L2HxhjnpTPGYAAAAASUVORK5CYII=" alt="Custom Icon" style="width: 15px; height: 15px; margin-right: 10px;">
          </template>
        </van-notice-bar>
      </div>
      <swiper class="banner_swiper" :options="bannerSwiperOption" style="background: unset;height: 160px;">
        <swiper-slide v-for="(v,key) in banners" :key="key" style="border-radius: 15px;">
          <van-image class="banner_img" :src="`${v.url}`" width="100%" height="160px">
            <template v-slot:loading style="border-radius: 15px;">
              <van-loading type="circular" style="border-radius: 15px;" />
            </template>
          </van-image>
        </swiper-slide>
      </swiper>
    </div>

    <!-- 分类按钮 -->
    <div style="width: 100%;height: 58px;"></div>
    <div style="width: 94%; background: repeating-linear-gradient(-60deg, #f85c9a, #f64a8e, #f85c9a, #f64a8e, #f85c9a, #f64a8e, #f85c9a, #f64a8e); margin: 8px auto; border-radius: 8px; padding: 8px; color: #fff; box-shadow: 0 0 .2px rgba(253, 16, 107, .51);">
      <div style="display: flex;justify-content: flex-start;align-items: center;">
        <div style="border-right: 1px solid #fff;width: 40%;">
          <img src="/img/logo.png" style="height:108px" />
        </div>
        <div style="width: 60%; padding-left: 10px; line-height: 18px; font-size: 12px; text-align: left;color:#fff">
          {{$t("foorter.top1")}}
        </div>
      </div>
      <div style="font-size: 12px; padding: .8rem 1rem 0;line-height:18px;color:#fff">
        {{$t("foorter.top2")}}
      </div>
    </div>

    <!-- 核心列表 -->
    <div :style="index1?'display:block':'display:none'" style="margin-left: 1.5%; padding: 0px 5px 20px 5px; width: 97%; border-radius: 2px 2px .66667rem .66667rem;">
      <div class="card-grid">
        <div class="card-item" v-for="item in datalist" :key="item.id" @click="toDetail(item.id)">
          
          <!-- 图片区域 -->
          <div class="card-img-box">
            <van-image class="card-img" :src="item.img_url" fit="cover" />
            
            <!-- 编号标签（左上角） -->
            <div class="id-badge">{{ item.xuanfei_name }}</div>

            <!-- 底部半透明信息遮罩层 -->
            <div class="card-info-overlay">
              <div class="info-top">
                <!-- 评分（在 location-tag 左侧） -->
                <div class="rating">
                  <span class="heart-icon">❤</span>
                  <span class="score">10.0</span>
                </div>
                
                <!-- 距离标签（右上角） -->
                <span class="location-tag">
                  <img src="/img/home/dingwei1.png" class="loc-icon" />
                  {{ item.class_name }}
                </span>
              </div>
              <div class="info-bottom">
                <!-- 左侧认证标签 -->
                <div class="verified-badge">{{$t("index.recmonmand")}}</div>
                <!-- 右侧认证标签 -->
                <div class="verified-badge">{{$t("index.authentication")}}</div>
              </div>
              
              <!-- 评分星星（在 info-bottom 下方） -->
<div class="stars-row">
<div style="width: 100%;"><div style="display: flex; align-items: center;padding: 0px 0px 4px 0px;">
              <van-rate v-model="item.number" color="#ffd21e" size="20px" />
            </div></div>
                    </div>
            </div>
          </div>

          <!-- 预约按钮（宽度100%） -->
          <div class="appointment-btn">{{$t("index.about")}}</div>
        </div>
      </div>
    </div>

    <!-- 其他 Tab 内容保持不变 -->
    <div :style="index3?'display:block':'display:none'" style="background: linear-gradient(rgb(254, 89, 134), rgb(255, 132, 139)); width: 96%; margin: 0px auto 30px; border-radius:0 2px 2px 0px; overflow: hidden; padding-bottom: 10px;color: #fff;padding: 0 10px 10px 10px;">
      {{$t("foorter.top3")}}
    </div>
    <div :style="index2?'display:block':'display:none'" style="background: linear-gradient(rgb(254, 89, 134), rgb(255, 132, 139)); width: 96%; margin: 0px auto 30px; border-radius:0 2px 2px 0px; overflow: hidden; padding-bottom: 10px;">
      <div style="color: rgb(255, 232, 105); text-align: center; padding: 10px 0px;">
        當前 {{this.basicData.online}} 人在線匹配
      </div>
      <div class="OnlineMatching" style="height: 160px;">
        <div class="scroll-container">
          <ul class="scroll-list" :style="{ transform: `translateY(-${currentIndex * itemHeight}px)` }">
            <li v-for="(item, index) in displayList" :key="index" style="height: 40px;line-height: 40px;text-align: center">
              {{ item }}  {{$t("auth.top7")}}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div style="padding-bottom: 55px;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      notice: this.$t("index.loading"),
      translateY: -18,
      containerHeight: 0,
      listgun: [],
      currentIndex: 0,
      timer: null,
      itemHeight: 40, 
      hasToken: false,index1:true,index2:false,index3:false,
      basicData: [],
      datalist: [],
      groupedData: [],
      banners: [{}],
      bannerSwiperOption: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        speed: 800,
        autoplay: true,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows: true
        }
      },
      tagTypes: ['primary', 'success', 'danger', 'warning']
    };
  },computed: {
    displayList() {
      return [...this.listgun, ...this.listgun];
    },
  },
  methods: {
    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        this.basicData = res.data;
        this.listgun=res.data.gun;
        this.getNotice(this.basicData);
        this.getBanner(this.basicData);
      });
    },
    getHotLottery() {
      this.$http({
        method: "get",
        url: "lottery_hot",
      }).then((res) => {
        console.log(res, 11)
      });
    },
    getBanner(data) {
      this.banners = data.banners;
    },
    toLogin(str) {
      this.$router.push({ path: str });
    },
    getNotice(data) {
      this.notice = data.notice;
    },
    toDetail(id) {
      this.$router.push({ path: "/detail", query: { id: id } });
    },toStatus(id) {
      if(id==1){this.index1=true;this.index2=false;this.index3=false;}if(id==2){this.index1=false;this.index2=true;this.index3=false;}if(id==3){this.index1=false;this.index2=false;this.index3=true;}},
    checkToken() {
      const token = localStorage.getItem("token");
      this.hasToken = !!token;
    },startScroll() {
      this.timer = setInterval(() => {
        this.currentIndex++;
        if (this.currentIndex >= this.listgun.length) {
          this.currentIndex = 0;
        }
      }, 1000);
    },
    pause() {
      clearInterval(this.timer);
    },
    resume() {
      this.startScroll();
    },
    getxuanfeilist() {
      this.$http({
        method: "get",
        url: "xuanfeilist1",
        data: { id: 0, page: 1 ,home_class:2},
      }).then((res) => {
        const lanng = this.$t("auth.lang");
        this.datalist = res.data;
        this.datalist.forEach(item => {
          const parts = item.flag.split('|')
          lanng == 'zh' ? item.flag = parts[0] : lanng == 'en' ? item.flag = parts[1] : lanng == 'ja' ? item.flag = parts[2] : item.flag = parts[3]
          item.flagArray = item.flag.split('，');
        })
        const chunkSize = 2;
        this.groupedData = this.datalist.reduce((acc, item, index) => {
          if (index % chunkSize === 0) acc.push([]);
          acc[Math.floor(index / chunkSize)].push(item);
          return acc;
        }, []);
      });
    },
  },
  mounted() {
    this.startScroll();
  },beforeUnmount() {
    clearInterval(this.timer);
  },
  created() {
    this.checkToken();
    this.getBasicConfig();
    this.getxuanfeilist();
    this.getHotLottery()
  },
};
</script>

<style lang="less" scoped>
/* 头部、Banner 等原有样式保持不变... */
.header {
  height: 13vw;
}
.header_content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  margin: 0 40px;
  color: #fff;
  .img {
    height: 80px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.banner_swiper {
  width: 100%;
  padding: 0 20px
}
.banner_img {
  border-radius: 30px;
}
.notice-swiper {
  height: 11vw;
  font-size: 4vw;
  border-radius: 7vw;
}
.zhong a {
  color: #ea4d4d;
  background: #fff;
  padding: 12px 32px;
  margin-right: 12px;
  border-radius: 106px;
}
.zhong .act {
  background: linear-gradient(180deg, #fff2ef, #fadad7, #f7cac8);
}
.OnlineMatching {
  overflow: hidden;
}
.scroll-container {
  overflow: hidden;
}
.scroll-list {
  transition: transform 0.5s ease;
}
.scroll-list li {
  text-align: center;
  color: #fff;
  font-size: 4vw;
}

/* ========================================= */
/* 网格卡片布局 (每行两个)                    */
/* ========================================= */
.card-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12PX;
  padding: 10PX 5PX;
}

.card-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  border-radius: 12PX;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 4PX 8PX rgba(0,0,0,0.1);
}

.card-img-box {
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 4;
  overflow: hidden;
}

.card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* 编号标签（左上角） */
.id-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 12PX;
  font-weight: bold;
  padding: 4PX 10PX;
  border-radius: 4PX;
  z-index: 10;
}

/* 底部半透明信息遮罩 */
.card-info-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 8PX 10PX;
  background: linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%);
  color: #fff;
  display: flex;
  flex-direction: column;
}

.info-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.rating {
  display: flex;
  align-items: center;
  gap: 4PX;
}

.heart-icon {
  color: #ff4d6d;
  font-size: 14PX;
}

.score {
  font-weight: bold;
  font-size: 13PX;
  color: #ffd21e;
  text-shadow: 0 1PX 2PX rgba(0, 0, 0, 0.5);
}

.location-tag {
  display: flex;
  align-items: center;
  gap: 4PX;
  background: #eab977;
  color: #333;
  font-size: 10PX;
  font-weight: 700;
  padding: 2PX 10PX;
  border-radius: 20PX;
}

.location-tag .loc-icon {
  width: 14PX;
  height: 14PX;
  vertical-align: middle;
  display: block;
}

.info-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.verified-badge {
  font-size: 9PX;
  color: #fff;
  background: rgba(255, 255, 255, 0.2);
  padding: 1PX 8PX;
  border-radius: 10PX;
  font-weight: 500;
  text-shadow: 0 1PX 2PX rgba(0,0,0,0.3);
  letter-spacing: 0.5PX;
}

/* 评分星星行（在 info-bottom 下方） */
.stars-row {
  padding: 4PX 0 2PX;
  display: flex;
  justify-content: center;
}

/* 预约按钮（宽度100%） */
.appointment-btn {
  width: 100%;
  background: linear-gradient(90deg, #fa6ba6, #f32879);
  color: #fff;
  border-radius: 20PX;
  padding: 8PX 0;
  text-align: center;
  font-size: 14PX;
  font-weight: bold;
}
</style>